import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { appWithTranslation } from 'next-i18next';
import { AppProps } from 'next/app';
import '../styles/global.css';

const configuration: Configuration = {
  auth: {
    clientId: `${process.env.NEXT_PUBLIC_CLIENT_ID}`,
  },
};

const pca = new PublicClientApplication(configuration);

const MyApp = ({ Component, pageProps }: AppProps) => (
  <MsalProvider instance={pca}>
    <Component {...pageProps} />
  </MsalProvider>
);

export default appWithTranslation(MyApp);
